type Falsy = false | null | undefined;

export const hasVersion = (key?: string | Falsy) => {
  return (key || '').includes('@');
};

export const stripVersion = (key: string | Falsy) => {
  key = key || '';
  return key.split('@')[0];
};

export const getVersion = (key: string | Falsy) => {
  return (key || '').split('@')[1] || '';
};
